import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const voiceModeInterfaceActionEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map